import OriginalScrollHint from 'scroll-hint'
import 'scroll-hint/css/scroll-hint.css'
export class ScrollHint {
  constructor() {
    new OriginalScrollHint('.js-scrollable', {
      // scrollHintIconAppendClass: 'scroll-hint-icon-white',
      suggestiveShadow: true,
      i18n: {
        scrollable: 'スクロールできます',
      },
    })
  }
}
